import http from '@/utils/http.js' // 引入封装的request.js文件
import common from '@/config/common.js'

// 查询我的订单
export function querymyOrderList(data) {
    return http.request({
        url: common.url + '/papi/order/myOrderList',
        method: 'get',
        params: data
    })
}

// 查询我的订单
export function submitInvoice(data) {
    return http.request({
        url: common.url + '/papi/order/submitInvoice',
        method: 'get',
        params: data
    })
}




